import { render } from "./LoginReset.vue?vue&type=template&id=3fe8ffb8&scoped=true&ts=true"
import script from "./LoginReset.vue?vue&type=script&lang=ts"
export * from "./LoginReset.vue?vue&type=script&lang=ts"

import "./LoginReset.vue?vue&type=style&index=0&id=3fe8ffb8&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe8ffb8"]])

export default __exports__